"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var NumberBadge_1 = require("./NumberBadge");
exports.default = NumberBadge_1.default;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/components/atoms/NumberBadge/index.js
// module id = 1793
// module chunks = 8